// blog dynamic resize to line buttons
function adjustButtonHeight() {
  if ($(window).width() > 767 && $('body.template-blog22').length > 0) {
    var h2_height = 0;
    $('.article h2').css('height','auto');
    $('.article h2').each(function(){
      if ($(this).height() > h2_height) {
        h2_height = $(this).height();
      }
    });
    $('.article h2').css('height',h2_height);

    var excerpt_height = 0;
    $('.excerpt-container').css('height','auto');
    $('.excerpt-container').each(function(){
      if ($(this).height() > excerpt_height) {
        excerpt_height = $(this).height();
      }
    });
    $('.excerpt-container').css('height',excerpt_height);
  } else {
    $('.article h2').css('height','auto');
    $('.excerpt-container').css('height','auto');
  }
}

/*
$(window).on('load', function(){
});
*/

$(window).resize(function(){
  adjustButtonHeight();
});

$(function(){
  adjustButtonHeight();

});
